var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 4,
    fill: "#FFF3F4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2437_87996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 13.7731L9.05044 17.7202C8.94954 17.8234 8.8097 17.8794 8.66574 17.8747C8.44743 17.873 8.25154 17.7409 8.16775 17.5398C8.08338 17.3381 8.12763 17.1064 8.27986 16.9501L12.2294 13.003L8.27986 9.05593C8.1766 8.9551 8.12055 8.81534 8.12528 8.67147C8.12174 8.527 8.17779 8.38784 8.27986 8.28583C8.38193 8.18382 8.52118 8.1278 8.66574 8.13135C8.8097 8.12663 8.94954 8.18264 9.05044 8.28583L13 12.2329L16.9496 8.28583C17.1041 8.12898 17.339 8.0818 17.5425 8.16672C17.7455 8.25163 17.8771 8.45093 17.8747 8.67147C17.8794 8.81535 17.8234 8.9551 17.7201 9.05594L13.7706 13.003L17.7201 16.9501C17.9207 17.1648 17.9154 17.4997 17.7072 17.7073C17.4995 17.9154 17.1643 17.9207 16.9496 17.7202L13 13.7731Z",
    fill: "#DF2935"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2437_87996"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderDelete);
export default __webpack_public_path__ + "static/media/order_delete.3623e1aea212f3f94f617928c0e0ee3a.svg";
export { ForwardRef as ReactComponent };